import { CardProps } from "@ppb/the-wall-common/types";
import { FunctionComponent, ReactNode } from "react";
import { Card } from "@ppb/the-wall-web";
import { CardTheme } from "@ppb/the-wall-common/types/Card/Card.types";

import styles from "./PebbleSection.web.css";

export const PebbleSection: FunctionComponent<
  Pick<CardProps, "title"> & {
    card: ReactNode;
  }
> = ({ title, card }) => {
  return (
    <div className={styles.pebbleSectionContainer}>
      <Card startOpen theme={CardTheme.PRIMARY}>
        <div className={styles.title}>{title}</div>
        <div>{card}</div>
      </Card>
    </div>
  );
};
